/* eslint-disable jsx-a11y/media-has-caption */
import React from "react";
import clsx from "clsx";
import formatTitle from "../common/formatTitle";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Grid from "@material-ui/core/Grid";
import { Button } from "gatsby-material-ui-components";
import ArrowIcon from "@material-ui/icons/ArrowForward";
import Typography from "@material-ui/core/Typography";
import News1 from "./news1.png";
import News2 from "./news2.png";
import News3 from "./news3.png";
import ArrowButton from "../common/ArrowButton";

const useStyles = makeStyles((theme) => ({
  lastRow: {
    padding: "10% 10% 5% 10%",
  },
  lastRowMobile: {
    padding: theme.layout.paddingLastRowMobile,
  },
  paragLimit: {
    maxWidth: "60%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  newsTitle: {
    fontWeight: "1000",
    fontSize: "1.1em",
    textAlign: "center",
    marginTop: theme.spacing(4),
  },
  grow: {
    flexGrow: 1,
  },
  enLight: {
    color: theme.palette.primary.light,
  },
  btn: {
    padding: 0,
  },
  cardContainer: {
    "& :hover": {
      boxShadow: "0px 30px 50px rgba(67,67,68, 0.109804);",
    },
  },
  card: {
    border: "solid 4px #CCD4E6",
    borderRadius: 5,
    flexGrow: 1,
    textAlign: "center",
    padding: theme.spacing(10),
    "& :hover": {
      boxShadow: "none",
    },
  },
}));

const News = ({ langKey, title, btnLabel }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));
  return (
    <Grid
      item
      className={clsx({
        [classes.lastRow]: matches,
        [classes.lastRowMobile]: !matches,
      })}
      container
      direction="column"
      spacing={matches ? 4 : 2}
    >
      <Grid
        item
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        spacing={1}
      >
        <Grid item>
          <Typography variant="h1">{formatTitle(title)}</Typography>
        </Grid>
        <Grid item>
          <ArrowButton
            label={btnLabel}
            to={`/${langKey}/media-press`}
            className={classes.btn}
            color="primary"
            noPaddingRight
            noPaddingLeft
          />
        </Grid>
      </Grid>
      <Grid item container direction={matches ? "row" : "column"} spacing={4}>
        <Grid item xs={12} lg={4} container direction="column">
          <Grid
            item
            className={classes.cardContainer}
            component={Button}
            href="http://www.traffex.com/"
            target="_blank"
            disableRipple
          >
            <div className={classes.card}>
              <img src={News1} alt="news1" width="100%" height="auto" />
            </div>
          </Grid>
          <Grid item>
            <Typography variant="h6" className={classes.newsTitle}>
              Traffex-Parkex 2021
              <br /> France
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={4} container direction="column">
          <Grid
            item
            className={classes.cardContainer}
            component={Button}
            href="https://vivatechnology.com/"
            target="_blank"
            disableRipple
          >
            <div className={classes.card}>
              <img src={News2} alt="news1" width="100%" height="auto" />
            </div>
          </Grid>
          <Grid item>
            <Typography variant="h6" className={classes.newsTitle}>
              Viva Technology 2021
              <br /> France
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={4} container direction="column">
          <Grid
            item
            className={classes.cardContainer}
            component={Button}
            href="https://an2v.org/les-nuits-de-lan2v/"
            target="_blank"
            disableRipple
          >
            <div className={classes.card}>
              <img src={News3} alt="news1" width="100%" height="auto" />
            </div>
          </Grid>
          <Grid item>
            <Typography variant="h6" className={classes.newsTitle}>
              Nuit de l’AN2V 2021
              <br />
              France
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default News;
